// extracted by mini-css-extract-plugin
export default {"annotation":"Annotation-module__annotation--XyhuZ","annotationSource":"Annotation-module__annotationSource--_lhYD","annotationMessage":"Annotation-module__annotationMessage--vtkTa"};